import { Stack } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";

import ActionButton from "./cellActions.tsx/ActionButton";
import { PRODUCT_STATUS } from "../../../models/Product";
import { useUserStore } from "../../../stores/userStore";

interface renderActionsCellContentProps {
  status: PRODUCT_STATUS;
  name: string;
  id: string;
}

const renderActionsCellContent = ({
  id: productId,
  name,
  status,
}: renderActionsCellContentProps) => {
  const userActions = useUserStore(state => state.userActions);
  const actions = userActions && userActions[status];

  return (
    <Stack direction="row" spacing={1} alignItems={"center"}>
      {actions?.map(action => (
        <ActionButton
          key={`${productId}-${action}`}
          action={action}
          productId={productId}
          productName={name}
          customStyle={{ height: 32 }}
        />
      ))}
    </Stack>
  );
};

const ActionsCell = (params: GridRenderCellParams) => {
  return renderActionsCellContent(params.value);
};

export default ActionsCell;
